import { render } from "./ClinicHealthSystems.vue?vue&type=template&id=882e5a16&scoped=true&lang=pug"
import script from "./ClinicHealthSystems.vue?vue&type=script&lang=js"
export * from "./ClinicHealthSystems.vue?vue&type=script&lang=js"

import "./ClinicHealthSystems.vue?vue&type=style&index=0&id=882e5a16&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-882e5a16"]])

export default __exports__